import { config } from "../configs/config";
import { h } from "@/app/helpers";
import Axios from "axios";

export async function getAll(params, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/admin/discounts`,
        method: "get",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
        },
        params,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function create(data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/admin/discounts`,
        method: "post",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}

export async function update(id, data, showMessage = false) {
    const response = await Axios({
        url: `${config.apiUrl}/v1/admin/discounts/${id}`,
        method: "put",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            _csrf: "N2FTAKVmu123Oc70CVZwiYlZ",
        },
        data,
    });
    return h.api.handleApiResponse(response, showMessage);
}
